// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WVb4A","importantInfo":"styles_importantInfo__1vp2u"};